import { defineComponent, onMounted, ref } from 'vue'
import {
  deleteCoupletTemplate,
  getCoupletTemplateList,
  saveCoupletTemplate
} from './api'

export default defineComponent({
  name: 'CoupletView',
  setup() {
    const title = ref('')
    const type = ref('')
    const leftText = ref('')
    const rightText = ref('')
    const templateList = ref([])
    const loading = ref(false)
    const saving = ref(false)

    const fetchTemplateList = async () => {
      loading.value = true
      try {
        const response = await getCoupletTemplateList()
        templateList.value = response.data || []
      } catch (error) {
        console.error('获取挽联模板失败:', error)
        alert('获取挽联模板失败，请稍后重试')
      } finally {
        loading.value = false
      }
    }

    const resetForm = () => {
      title.value = ''
      type.value = ''
      leftText.value = ''
      rightText.value = ''
    }

    const handleSave = async () => {
      if (!title.value.trim() || !type.value.trim() || !leftText.value.trim() || !rightText.value.trim()) {
        alert('类型、标题、左联、右联都不能为空')
        return
      }

      saving.value = true
      try {
        await saveCoupletTemplate({
          title: title.value.trim(),
          type: type.value.trim(),
          left_text: leftText.value.trim(),
          right_text: rightText.value.trim()
        })
        alert('挽联模板新增成功')
        resetForm()
        await fetchTemplateList()
      } catch (error) {
        console.error('保存挽联模板失败:', error)
        alert(error.message || '保存失败，请稍后重试')
      } finally {
        saving.value = false
      }
    }

    const handleDelete = async (template) => {
      if (!confirm(`确定删除模板「${template.title}」吗？`)) return

      loading.value = true
      try {
        await deleteCoupletTemplate(template.id)
        alert('删除成功')
        await fetchTemplateList()
      } catch (error) {
        console.error('删除挽联模板失败:', error)
        alert('删除失败，请稍后重试')
      } finally {
        loading.value = false
      }
    }

    onMounted(() => {
      fetchTemplateList()
    })

    return {
      title,
      type,
      leftText,
      rightText,
      templateList,
      loading,
      saving,
      handleSave,
      handleDelete
    }
  }
})
